const FIELD_LABELS = {
  phone: "Phone",
  firstName: "First name",
  lastName: "Last name",
  name: "Name",
  gender: "Gender",
  email: "Email",
  contact: "Email or phone",
  RFIDCardIdField: "RFID card",
  cardMembershipId: "RFID card",
  assignedStaff: "Assigned staff",
  referralSource: "Referral source",
  member: "Member",
  packages: "Packages",
  products: "Products",
  trainer: "Instructor",
  trainers: "Instructors",
  permissions: "Permissions",
  title: "Title",
  attachment: "Identity document",
};

export const labelForField = (field) =>
  FIELD_LABELS[field] ||
  String(field || "")
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (value) => value.toUpperCase());

export const problemsFromMap = (errors) =>
  Object.keys(errors || {}).map((field) => ({
    field,
    label: labelForField(field),
    message: errors[field],
  }));

export const problemsFromReason = (reason) => {
  if (!reason) return [];
  if (reason.errors && typeof reason.errors === "object") {
    return problemsFromMap(reason.errors);
  }
  const fields = reason.fields || [];
  if (fields.length) {
    return fields.map((field) => ({
      field,
      label: labelForField(field),
      message: reason.message
        ? `${labelForField(field)}: ${reason.message}`
        : `${labelForField(field)} needs attention`,
    }));
  }
  if (reason.message) {
    return [{ field: "", label: "", message: reason.message }];
  }
  return [];
};

export const problemsText = (problems, fallback) => {
  const text = (problems || [])
    .map((item) => item && item.message)
    .filter(Boolean)
    .join(". ");
  return text || fallback || "";
};

export const isIdentityDocumentError = (item) =>
  Boolean(
    item &&
      (item.field === "attachment" ||
        item.key === "attachment" ||
        /identity document/i.test(item.message || ""))
  );

const salePackages = (draft) => {
  const value = draft && draft.fields && draft.fields.packages;
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

export const saleDraftNeedsIdentity = (draft) => {
  if (!draft || draft.type !== "sale") return false;
  if (draft.fields && draft.fields.attachment) return false;
  if (draft.fields && draft.fields.requiredAttachment) return true;
  if (salePackages(draft).some((pack) => pack && pack.requiredAttachment)) {
    return true;
  }
  return (draft.fieldErrors || []).some(isIdentityDocumentError);
};

export const withSaleIdentityProblem = (draft) => {
  if (!draft) return draft;
  if (draft.fields && draft.fields.attachment) return draft;
  const error = {
    field: "attachment",
    label: "Identity document",
    message: "Upload the member identity document.",
  };
  const fieldErrors = (draft.fieldErrors || []).some(isIdentityDocumentError)
    ? draft.fieldErrors
    : (draft.fieldErrors || []).concat(error);
  const missing = (draft.missing || []).includes("Identity document")
    ? draft.missing
    : (draft.missing || []).concat("Identity document");
  return {
    ...draft,
    fields: { ...(draft.fields || {}), requiredAttachment: true },
    fieldErrors,
    missing,
    ready: false,
    needsForm: true,
  };
};
